import { Typography } from "antd";
import React from "react";
import "./template-4.css";
import Image from "next/image";
import { IStaticTemplate4Props } from "../../Orchestrator/Types/Interface/IStaticTemplates";
import { BlocksRenderer } from "../Common/CMS/ReactBlockRender";
import { useIntl } from "react-intl";

const Template4 = ({
  title,
  image,
  subtitle,
  content,
  onBackClick
}: IStaticTemplate4Props) => {
  const intl = useIntl();

  return (
    <div className="template-main">
      <div className="container">

        {
          onBackClick && (
            <div className="align-items-center mb-20 ff-inter template4-back-btn"
              onClick={onBackClick}
            >
              <div className="align-items-center cursor-pointer" >
                <span className="mr-5 cursor-pointer d-flex back-btn-arrow">
                  <Image
                    src="/assets/booking/arrow-left.svg"
                    width={14}
                    height={14}
                    alt="back"
                  />
                </span>
                <span className="fs-16">
                  {intl.formatMessage({ id: "backText" })}
                </span>
              </div>
            </div>
          )
        }

        <Typography.Title level={1} className="title-text">
          {title}
        </Typography.Title>
        {image && (
          <Image
            title={title}
            src={image}
            alt={title}
            width={1200}
            height={270}
            // The image is styled `w-100` to fill the .container (max-width 1240px),
            // so tell next/image the real rendered width. Without `sizes` it assumed
            // the intrinsic width and only ever fetched w=640, which the browser then
            // upscaled across ~1200px — hence the pixelated banner.
            // The 540px clause is NOT the box width — the box is only ~335px
            // wide at a 375 viewport. Below 573px the CSS pins a 120px height
            // against 4.44:1 artwork, so `object-fit: cover` scales the source
            // until it covers the HEIGHT (1200 * 120/270 = 533px wide, the
            // outer third cropped off). `sizes` describes width only and no
            // browser accounts for object-fit when picking from the srcset, so
            // declaring the real 335px would fetch w384 and upscale it ~1.4x.
            // Above 573 the crop ends, `cover` binds on width, and the box
            // needs the full container width — 540px would then ask for LESS
            // than it needs. Same 573 as the CSS, deliberately: one number.
            // Keep the `100vw` literal: next/image only detects a vw-relative
            // size via /(^|\s)(1?\d?\d)vw/, which `calc(100vw - 40px)` does not
            // match — that drops it into the generic branch and adds 16-384px
            // candidates it should never pick here. The
            // container's 20px side padding makes 100vw a slight over-estimate,
            // which only ever over-fetches.
            sizes="(max-width: 573px) 540px, (max-width: 1240px) 100vw, 1200px"
            // Default quality (75) visibly softens a 1200px-wide hero banner.
            quality={90}
            // Above-the-fold LCP element. `preload` (which supersedes the
            // deprecated `priority` in Next 16 — setting both throws) buys
            // eager loading; it does NOT emit fetchpriority, and its ReactDOM
            // preload is ~inert here because the URL only exists after the atom
            // fills post-hydration. fetchPriority is what actually raises the
            // request priority, so both are set deliberately.
            preload
            fetchPriority="high"
            className="w-100 offers-detail-image"
          />
        )}
        <div className="content-container">
          {subtitle &&
            <Typography.Title level={2} className="subtitle">
              {subtitle}
            </Typography.Title>
          }
          <BlocksRenderer content={content} />
        </div>
      </div>
    </div>
  );
};

export default Template4;
